import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { SegmentTrackList } from '@unico-people/shared/enums/utils-enums';
import { TrackingSegmentService } from '@unico-people/shared/data-access-tracking-segment';

@Component({
  selector: 'app-top-navigation',
  templateUrl: './top-navigation.component.html',
  styleUrls: ['./top-navigation.component.scss']
})
export class TopNavigationComponent {
  @Input() hasBackLink = true;
  @Input() backLinkPath = '/';
  @Input() eventTarget!: string;
  @Input() hasStatusMenu!: boolean;
  @Input() hideButtons: boolean;
  @Input() active: string;
  @Output() eventBackEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() eventChangeStatusEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    public router: Router,
    private segment: TrackingSegmentService
  ) {}

  eventEmitterBack(): void {
    this.eventBackEmitter.emit(false);
  }

  changeStatus(status: string) {

    this.router.navigate(['/'], {
      queryParams: { status: status, page: 1 }
    });
    this.eventChangeStatusEmitter.emit(true);

    const segmentTrack = {
      active: SegmentTrackList.click_tab_active,
      inactive: SegmentTrackList.click_tab_inactive
    }
    this.segment.track(segmentTrack[status])
  }
}
